import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

class HintPanel extends Component {
  static propTypes = {
    hintType: PropTypes.string.isRequired,
    hintText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]).isRequired,
    partNumber: PropTypes.string,
    lineNumber: PropTypes.string,
    onSelectDefinition: PropTypes.func,
    onClose: PropTypes.func,
    highlightClass: PropTypes.string,
  };

  static defaultProps = {
    partNumber: '',
    lineNumber: '',
    onSelectDefinition: null,
    onClose: null,
    highlightClass: 'highlighted'
  };

  timeout = null;

  constructor(props) {
    super(props);
    this.state = {
      isCloseButtonVisible: false
    };
    this.panelElement = React.createRef();
  }

  componentDidMount() {
    const { onSelectDefinition } = this.props;
    if (!onSelectDefinition) return;
    if (!this.panelElement.current) {
      return;
    }
    const definitions = this.panelElement.current.querySelectorAll('dfn');
    Array
      .from(definitions)
      .forEach((definition) => {
        if (definition != null) {
          definition.addEventListener(
            'click',
            e => this.handleClickOnDefinition(e, onSelectDefinition),
            false
          );
        }
      });
  }

  componentWillUnmount() {
    const { onSelectDefinition } = this.props;
    if (!onSelectDefinition) return;
    if (!this.panelElement.current) {
      return;
    }
    const definitions = this.panelElement.current.querySelectorAll('dfn');
    Array
      .from(definitions)
      .forEach((definition) => {
        if (definition != null) {
          definition.removeEventListener(
            'click',
            e => this.handleClickOnDefinition(e),
            false
          );
        }
      });
  }

  handleClickOnDefinition(e) {
    const { onSelectDefinition } = this.props;
    onSelectDefinition(e.target.dataset.definition);
  }

  handleClose() {
    const { onClose } = this.props;
    if (!onClose) return;
    onClose();
  }

  /* eslint-disable-next-line react/no-unused-class-component-methods */
  highlight() {
    const { highlightClass } = this.props;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.panelElement.current.classList.remove(highlightClass);
      // eslint-disable-next-line
      void this.panelElement.current.offsetWidth;
    }
    this.panelElement.current.classList.add(highlightClass);
    this.timeout = setTimeout(
      () => {
        if (this.panelElement?.current) {
          this.panelElement.current.classList.remove(highlightClass);
        }
      },
      3000
    );
  }

  render() {
    const {
      hintType,
      hintText,
      partNumber,
      lineNumber
    } = this.props;
    const {
      isCloseButtonVisible
    } = this.state;
    return (
      <div
        id="hint-panel"
        style={ { fontStyle: hintType !== 'hint' ? 'italic' : 'normal' } }
        ref={ this.panelElement }
        className={ hintType }
        data-number={ partNumber || lineNumber }
        data-prefix={ (partNumber && 'Part') || (lineNumber && 'Line') }
        onMouseEnter={ () => this.setState({ isCloseButtonVisible: true }) }
        onMouseLeave={ () => this.setState({ isCloseButtonVisible: false }) }
      >
        { hintText }
        <button
          id="close-button"
          style={ { opacity: isCloseButtonVisible ? '.3' : '0' } }
          type="button"
          onClick={ () => this.handleClose() }
        />
      </div>
    );
  }
}

export default HintPanel;
